export const categories = [
  {
    slug: 'study-companion',
    name: '学习陪伴',
    description: '掌握科学的陪读方法，帮助孩子建立良好学习习惯，让陪伴更高效。',
    icon: 'ri-book-open-line',
    color: 'primary',
    imageSeq: 'cat-study-companion',
  },
  {
    slug: 'emotion-management',
    name: '情绪管理',
    description: '学会管理自己的情绪，理解孩子的内心世界，营造和谐家庭氛围。',
    icon: 'ri-heart-pulse-line',
    color: 'accent',
    imageSeq: 'cat-emotion',
  },
  {
    slug: 'parent-child-communication',
    name: '亲子沟通',
    description: '破解沟通障碍，用爱与智慧搭建与孩子之间的理解之桥。',
    icon: 'ri-chat-smile-2-line',
    color: 'secondary',
    imageSeq: 'cat-communication',
  },
  {
    slug: 'education-planning',
    name: '升学规划',
    description: '从小学到大学，为孩子规划清晰的升学路径，把握每个关键节点。',
    icon: 'ri-road-map-line',
    color: 'primary',
    imageSeq: 'cat-planning',
  },
];

export const articles = [
  // 学习陪伴
  {
    slug: 'how-to-create-study-plan',
    title: '如何帮孩子制定一份科学的学习计划表',
    category: 'study-companion',
    excerpt: '一份好的学习计划是孩子学习之路上的导航仪。本文将分享如何根据孩子的年龄、学习特点和作息规律，制定一份切实可行的学习计划，让孩子的每一天都充实而高效。',
    content: `## 为什么需要学习计划？

很多妈妈都会遇到这样的困扰：孩子放学回家后不知道先做什么后做什么，总是拖拖拉拉，作业写到很晚。这背后反映的往往不是孩子不够努力，而是缺乏一个清晰的学习计划作为指引。

学习计划就像一张地图，让孩子清楚地知道目标在哪里、路径怎么走。对于小学阶段的孩子来说，这个习惯的培养尤其重要。

## 制定学习计划的五个步骤

### 第一步：了解孩子的"高效时间"

每个孩子的精力节奏都不同。有的孩子放学后需要先吃点东西、休息半小时，有的孩子则可以一鼓作气。作为妈妈，你需要观察孩子的状态，找到Ta每天精力最充沛的时间段，把最重要的学习任务安排在这个时段。

### 第二步：区分"必须做"和"可以做"

把每天的学习任务分为两类：必须完成的（如学校作业、复习当天所学）和可以选择性完成的（如课外阅读、额外练习）。这样做的好处是让孩子先保证核心任务完成，在有余力的情况下再拓展。

### 第三步：使用"番茄工作法"

对于注意力容易分散的孩子，建议采用番茄工作法：专注学习25分钟，休息5分钟。每完成4个番茄钟，休息15-20分钟。这种节奏感能有效提升学习效率。

### 第四步：留出缓冲时间

计划不要排得太满。建议每天留出30-45分钟的缓冲时间，用于应对突发情况或弥补未完成的任务。过于紧凑的计划只会让孩子和妈妈都感到焦虑。

### 第五步：定期回顾与调整

每周花10分钟和孩子一起回顾计划执行情况：哪些做得好？哪些需要改进？根据实际情况灵活调整，让计划真正服务于学习，而不是成为负担。

## 给妈妈的小贴士

记住，制定计划的目的不是控制孩子，而是帮助Ta建立自主管理的能力。在陪伴孩子执行计划的过程中，多一些鼓励，少一些责备。当你看到孩子因为完成计划而露出的自信笑容时，所有的付出都是值得的。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20home%20study%20desk%20scene%20with%20a%20notebook%20and%20colorful%20pens%20on%20a%20wooden%20table%2C%20soft%20natural%20light%20streaming%20through%20a%20window%2C%20minimalist%20aesthetic%2C%20warm%20cream%20and%20soft%20coral%20tones%2C%20lifestyle%20photography%2C%20clean%20composition&width=800&height=500&seq=article-plan-01&orientation=landscape',
    author: '王老师',
    role: '资深教育顾问',
    readTime: 8,
    date: '2024-12-15',
    featured: true,
    tags: ['学习计划', '时间管理', '学习习惯'],
  },
  {
    slug: 'homework-guidance-mistakes',
    title: '辅导作业时，这5个常见错误你犯过吗？',
    category: 'study-companion',
    excerpt: '辅导孩子写作业几乎是每位妈妈的必修课，但有些看似"帮助"的行为反而会阻碍孩子的成长。本文整理了5个最常见的辅导误区，看看你中了几个。',
    content: `## 错误一：全程守候，随时纠错

很多妈妈习惯坐在孩子旁边，看到写错的字立刻指出，看到算错的题马上纠正。这种"鹰眼式"辅导看似认真负责，实则剥夺了孩子独立思考和自我纠错的机会。

**正确做法**：让孩子独立完成作业，全部做完后再统一检查和讲解。给孩子犯错的空间，让Ta从错误中学习。

## 错误二：直接告诉答案

当孩子遇到不会的题时，最省事的做法就是直接告诉答案。但这样的"帮助"只是让孩子抄了一遍答案，并没有真正理解知识。

**正确做法**：用提问引导孩子思考——"这道题在考什么知识点？""你之前有没有遇到过类似的题？"通过提问激发孩子的思维。

## 错误三：拿别人家的孩子比较

"你看人家小明作业写得多工整""小红每次考试都是第一名"。这种比较不仅不能激励孩子，反而会伤害Ta的自信心。

**正确做法**：关注孩子自身的进步。即使只比上次多对了一道题，也值得表扬。成长是和过去的自己比，不是和别人比。

## 错误四：情绪失控，大吼大叫

辅导作业时血压升高几乎是每位妈妈都经历过的。但大吼大叫只会让孩子更加紧张，甚至对学习产生恐惧。

**正确做法**：当你感到快要爆发时，先离开现场冷静5分钟。回来后再用平和的语气继续。如果实在忍不住，可以和孩子约定一个"暂停信号"。

## 错误五：包办代替，过度干预

帮孩子整理书包、帮孩子记作业、帮孩子做手工作业……这些"好心"的行为让妈妈自己疲惫不堪，也让孩子失去了培养自理能力的机会。

**正确做法**：根据孩子的年龄适当放手。一年级的孩子可以自己整理文具，三年级可以自己记作业，五年级可以完全自主管理学习用品。相信孩子，他们都是被低估的小能手。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mother%20and%20child%20sitting%20together%20at%20a%20desk%20studying%2C%20warm%20lighting%2C%20gentle%20atmosphere%2C%20soft%20cream%20and%20coral%20tones%2C%20minimalist%20interior%2C%20lifestyle%20photography%2C%20harmonious%20composition&width=800&height=500&seq=article-homework-02&orientation=landscape',
    author: '李妈妈',
    role: '家庭教育实践者',
    readTime: 6,
    date: '2024-11-28',
    featured: false,
    tags: ['作业辅导', '教育误区', '亲子关系'],
  },
  {
    slug: 'reading-habit-cultivation',
    title: '让孩子爱上阅读的10个秘诀',
    category: 'study-companion',
    excerpt: '阅读是孩子成长的基石。如何让孩子从"要我读"变成"我要读"？这10个经过验证的方法，帮助妈妈轻松培养孩子的阅读兴趣。',
    content: `阅读是打开世界的窗口。一个爱阅读的孩子，拥有更广阔的视野、更丰富的想象力和更强的理解能力。以下是10个帮助孩子爱上阅读的秘诀：

1. **营造家庭阅读氛围**：让孩子看到你在读书，而不是总在看手机。

2. **打造舒适的阅读角**：一个温馨的小角落，一盏柔和的灯，一个舒服的靠枕，就能成为孩子的阅读乐园。

3. **从孩子的兴趣出发**：男孩子喜欢恐龙和太空，女孩子喜欢童话和动物，从兴趣出发选书事半功倍。

4. **不限定"必须读完"**：允许孩子翻几页就换书，重要的是保持阅读的愉悦感。

5. **亲子共读时光**：每天15-20分钟的共读，既是阅读习惯的培养，也是珍贵的亲子时光。

6. **去图书馆"寻宝"**：定期带孩子去图书馆，让Ta自己挑选想看的书，这种自主权会大大激发阅读热情。

7. **读完后的讨论**：和孩子聊聊书里的故事，问Ta"你最喜欢哪个角色？为什么？"

8. **不要用阅读作为惩罚**：把阅读当成奖励，而不是"你今天不乖，罚你去读书"。

9. **利用有声书过渡**：对于阅读能力还不强的孩子，有声书是很好的桥梁。

10. **耐心等待，静待花开**：阅读习惯的培养不是一朝一夕的事，给足时间，你终会看到花开的那天。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cozy%20reading%20nook%20with%20a%20child%20reading%20a%20colorful%20book%20on%20a%20soft%20cushion%2C%20warm%20natural%20light%2C%20bookshelves%20in%20background%2C%20cream%20and%20soft%20amber%20tones%2C%20minimalist%20home%20interior%2C%20lifestyle%20photography&width=800&height=500&seq=article-reading-03&orientation=landscape',
    author: '张老师',
    role: '语文教育专家',
    readTime: 7,
    date: '2024-11-10',
    featured: true,
    tags: ['阅读习惯', '亲子共读', '兴趣培养'],
  },
  // 情绪管理
  {
    slug: 'mom-anxiety-management',
    title: '妈妈的焦虑：我该如何与自己的情绪和解？',
    category: 'emotion-management',
    excerpt: '当辅导作业变成"战争"，当孩子的成绩单让你夜不能寐——作为学生的妈妈，焦虑似乎无处不在。本文带你认识焦虑的根源，学会与情绪温柔相处。',
    content: `## 承认吧，你也会焦虑

在这个"鸡娃"成风的时代，妈妈们的焦虑值似乎一直在高位运行。朋友圈里别人家的孩子又是奥数金奖又是钢琴十级，而自家孩子连作业都写不明白——这种对比带来的焦虑，几乎每一个妈妈都经历过。

首先，请允许自己焦虑。焦虑不是软弱的表现，而是你作为母亲对孩子的深切关爱。但我们需要学会管理它，而不是被它吞噬。

## 焦虑的四个来源

### 来源一：信息过载
各种育儿文章、家长群、培训班广告……铺天盖地的信息让人觉得自己做得"还不够"，永远有更多的书要买、更多的班要报。

### 来源二：比较心理
朋友圈里看到的永远是别人最好的一面。但你没有看到的是：那个钢琴十级的孩子可能社交困难，那个奥数冠军可能每天睡不够6小时。

### 来源三：对未来的不确定
孩子的未来充满变数，这种不确定性让妈妈们本能地想要"掌控一切"。但我们能掌控的其实很有限。

### 来源四：自我要求过高
很多妈妈给自己定的标准是"完美的妈妈"——既要上班挣钱，又要辅导作业，还要保持优雅从容。这本身就是不切实际的。

## 与情绪和解的四步法

**第一步：觉察** — 当你感到心跳加快、呼吸急促、想要发火时，告诉自己："我现在正在焦虑。"

**第二步：暂停** — 给自己5分钟，离开当前场景，做几次深呼吸。不需要解决问题，只需要让情绪平复。

**第三步：分析** — 冷静后问自己：我到底在担心什么？这件事真的有那么严重吗？最坏的结果是什么？

**第四步：行动** — 区分"我能改变的"和"我无法改变的"。把精力集中在可以改变的事情上，接受那些无法改变的。

## 写在最后

亲爱的妈妈，你不需要完美。孩子需要的不是一个从不犯错的妈妈，而是一个真实、温暖、会笑也会哭的你。当你学会与自己的情绪和解时，你也在用行动教会孩子：情绪是可以被理解、被接纳、被管理的。这才是最珍贵的一课。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20peaceful%20woman%20sitting%20by%20a%20window%20with%20a%20cup%20of%20tea%2C%20soft%20morning%20light%2C%20calm%20and%20serene%20atmosphere%2C%20warm%20cream%20and%20soft%20rose%20tones%2C%20minimalist%20interior%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-anxiety-04&orientation=landscape',
    author: '林心理师',
    role: '国家二级心理咨询师',
    readTime: 9,
    date: '2024-12-08',
    featured: true,
    tags: ['情绪管理', '妈妈焦虑', '心理健康'],
  },
  {
    slug: 'child-mood-understanding',
    title: '读懂孩子的小情绪：不同年龄段孩子的心理特征',
    category: 'emotion-management',
    excerpt: '孩子突然发脾气、不愿意说话、总是磨蹭——这些行为背后藏着什么心理需求？了解不同年龄段孩子的心理特征，让你更懂孩子的心。',
    content: `## 为什么需要了解孩子的心理特征？

很多亲子冲突源于"不懂"——妈妈用自己的逻辑去判断孩子，却忽略了不同年龄段孩子的认知能力和心理需求完全不同。了解这些特征，不是为孩子的不当行为找借口，而是让我们能用更适合的方式去引导。

## 6-8岁：规则建立期

这个阶段的孩子开始进入小学，面临从"玩"到"学"的转变。

**典型表现**：
- 非常在乎老师的评价
- 喜欢有明确规则的环境
- 输赢意识开始萌芽
- 情绪波动大但恢复也快

**妈妈怎么做**：建立清晰的家庭规则，用"我们家的规矩是……"代替"你怎么又……"。多鼓励少批评，因为这个阶段的孩子特别需要正向反馈。

## 9-11岁：自我意识觉醒期

这个阶段的孩子开始形成独立的思想。

**典型表现**：
- "凭什么"成为口头禅
- 开始有自己的小秘密
- 同伴关系变得越来越重要
- 对不公平的事情特别敏感

**妈妈怎么做**：尊重孩子的意见，学会用商量的口吻而非命令。给孩子适当的自主空间，比如自己决定穿什么衣服、先做哪科作业。

## 12-15岁：青春期前期

这是亲子关系最敏感的时期。

**典型表现**：
- 情绪像过山车
- 开始挑战权威
- 极度在乎外貌和同伴评价
- 渴望被当作大人对待

**妈妈怎么做**：少说多听。这个阶段的孩子不缺道理，缺的是被理解的感觉。把"你不懂"变成"你能跟我说说吗？"`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20thoughtful%20child%20looking%20out%20a%20window%20with%20soft%20afternoon%20light%2C%20warm%20and%20gentle%20atmosphere%2C%20cream%20and%20soft%20amber%20tones%2C%20minimalist%20interior%2C%20editorial%20photography%2C%20emotional%20and%20tender%20mood&width=800&height=500&seq=article-mood-05&orientation=landscape',
    author: '陈心理师',
    role: '儿童发展心理学专家',
    readTime: 10,
    date: '2024-11-22',
    featured: false,
    tags: ['儿童心理', '情绪理解', '亲子关系'],
  },
  {
    slug: 'stress-relief-for-moms',
    title: '妈妈专属的减压清单：每天10分钟，找回内心的平静',
    category: 'emotion-management',
    excerpt: '当孩子的作业、家务、工作三重压力一起涌来，妈妈们需要属于自己的"喘息时刻"。这份专属减压清单简单实用，每天只需10分钟。',
    content: `## 妈妈们的身心透支

有调查显示，学生妈妈群体的压力水平在所有人群中位居前列。她们不仅要应对职场的竞争，还要承担大部分的家庭教育责任。长期的高压状态不仅影响身体健康，也会波及到亲子关系。

## 10分钟减压清单

### 早晨3分钟：正念呼吸
起床后不急着看手机，坐在床边做3分钟腹式呼吸。吸气4秒，屏住2秒，呼气6秒。这个简单的练习能重置你的神经系统。

### 午间2分钟：感恩记录
在手机上记下今天值得感恩的三件小事。可能是"今天阳光很好""孩子主动说了一句暖心的话""同事帮我带了咖啡"。感恩练习被证明能显著降低焦虑水平。

### 晚间5分钟：身体扫描
睡前躺在床上，从头到脚扫描身体的每个部位，感受哪里紧张就刻意放松。这是一种温和的正念冥想，帮助释放一天积累的紧张。

## 给妈妈的真心话

你不是超人，也不应该成为超人。照顾好自己，就是给孩子最好的礼物。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20peaceful%20woman%20practicing%20meditation%20on%20a%20yoga%20mat%20near%20a%20window%2C%20soft%20morning%20light%2C%20calm%20and%20serene%2C%20cream%20and%20soft%20sage%20green%20tones%2C%20minimalist%20interior%2C%20wellness%20lifestyle%20photography&width=800&height=500&seq=article-stress-06&orientation=landscape',
    author: '林心理师',
    role: '国家二级心理咨询师',
    readTime: 5,
    date: '2024-10-30',
    featured: false,
    tags: ['减压', '自我关怀', '正念'],
  },
  // 亲子沟通
  {
    slug: 'effective-communication-skills',
    title: '这样说孩子才会听：高效亲子沟通的黄金法则',
    category: 'parent-child-communication',
    excerpt: '"我说了多少遍了你怎么就是不听？"如果你经常说这句话，可能不是孩子的问题，而是沟通方式需要调整。掌握这6条黄金法则，让每次对话都成为亲子关系的加分项。',
    content: `## 沟通的真相

很多妈妈觉得沟通困难，是因为把"沟通"等同于"说服"——我说什么，你就得听什么。真正的沟通是双向的，是倾听和理解，而不是单向的命令输出。

## 黄金法则一：用"我"代替"你"

- ❌ "你怎么又把房间弄得这么乱！"
- ✅ "我看到房间有点乱，我有点担心这样会影响写作业的心情。"

"你"字开头的话语往往带有指责的意味，而"我"字开头则表达的是你的感受和需求，更容易让孩子接受。

## 黄金法则二：先连接，再纠正

当孩子情绪激动时，任何道理都是白说。先帮Ta把情绪平复——"妈妈知道你现在很生气，我们先深呼吸一下好不好？"情绪稳定后，再讨论问题。

## 黄金法则三：给选择题而非命令

- ❌ "快去写作业！"
- ✅ "你想先写数学还是先写语文？"

有限的选择让孩子感到被尊重，同时也达成了目的。

## 黄金法则四：积极倾听

当孩子跟你说话时，放下手机，看着Ta的眼睛，用"嗯""然后呢""这样啊"来回应。有时候孩子需要的不是建议，而是一个愿意认真听Ta说话的人。

## 黄金法则五：用描述代替评价

- ❌ "你这次考得真差！"
- ✅ "这次数学比上次少了5分，我们来看看是哪道题出了问题。"

描述事实，而不是贴标签。这样孩子才能把注意力放在解决问题上，而不是自我保护上。

## 黄金法则六：定期"专属时间"

每周安排一段只属于你和孩子的时间，不谈学习、不谈成绩，只是单纯地在一起——散步、下棋、做手工、聊聊天。这种高质量的陪伴是亲子关系最好的润滑剂。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20mother%20and%20child%20having%20a%20warm%20conversation%20on%20a%20cozy%20sofa%2C%20soft%20sunlight%2C%20gentle%20and%20loving%20atmosphere%2C%20cream%20and%20soft%20coral%20tones%2C%20minimalist%20living%20room%2C%20lifestyle%20photography&width=800&height=500&seq=article-comm-07&orientation=landscape',
    author: '赵老师',
    role: '家庭教育指导师',
    readTime: 8,
    date: '2024-12-20',
    featured: true,
    tags: ['亲子沟通', '教育方法', '倾听技巧'],
  },
  {
    slug: 'praise-the-right-way',
    title: '表扬孩子的艺术：为什么"你真棒"可能害了孩子？',
    category: 'parent-child-communication',
    excerpt: '"宝贝你真棒！"这句表扬几乎成了每位妈妈的口头禅。但你知道吗？不恰当的表扬方式可能会让孩子变得害怕挑战、依赖外部评价。学会正确的表扬方法，才能让孩子真正自信成长。',
    content: `## "你真棒"的问题在哪里？

"你真棒"是最常见的表扬，但也是最空洞的表扬。孩子不知道"棒"在哪里，久而久之，Ta会形成两种心态：

1. **固定型心态**："我很棒"是一个固定标签，所以我不愿意做任何可能暴露我"不棒"的事情。
2. **外部评价依赖**：我做事的动力来自别人的表扬，而不是内在的成就感。

## 正确的表扬公式

**描述行为 + 肯定努力 + 表达感受**

举个例子：
- ❌ "你这次考了100分，真棒！"
- ✅ "我看到你这两周每天都在认真复习，这次的100分是你努力的成果，妈妈为你感到骄傲！"

区别在于：前者表扬的是结果，后者表扬的是过程和努力。当孩子知道自己是因为努力而被认可时，Ta会更愿意面对挑战。

## 不同场景的表扬示范

### 场景一：孩子主动收拾了房间
- "你把书放回了书架，把玩具收进了箱子，整个房间看起来整洁多了。妈妈看到你这么有条理，真的很欣慰。"

### 场景二：孩子帮助了同学
- "你把铅笔借给了忘记带的同桌，这个举动很暖心。这说明你是一个会关心别人的孩子，妈妈觉得特别感动。"

### 场景三：孩子考试成绩进步了
- "从70分到85分，这个进步不容易。我知道你课后主动找老师问问题，还多做了一套练习。这些努力妈妈都看到了。"

## 特别提醒

表扬要真诚，不要为了表扬而表扬。孩子是很敏感的，他们能分辨出敷衍和真心的区别。而且，不是每件事都需要表扬——有时候一句"你完成了"就足够，让孩子学会为自己完成的事而感到满足，这才是最好的内在动力。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20proud%20child%20showing%20a%20drawing%20to%20mother%20in%20a%20bright%20room%2C%20warm%20sunlight%2C%20joyful%20moment%2C%20cream%20and%20soft%20amber%20tones%2C%20minimalist%20interior%2C%20lifestyle%20photography&width=800&height=500&seq=article-praise-08&orientation=landscape',
    author: '赵老师',
    role: '家庭教育指导师',
    readTime: 7,
    date: '2024-11-15',
    featured: false,
    tags: ['表扬方法', '自信心', '亲子沟通'],
  },
  {
    slug: 'screen-time-negotiation',
    title: '手机和平板大战：如何与孩子协商电子产品使用时间',
    category: 'parent-child-communication',
    excerpt: '每到假期就爆发"手机大战"？没收和放任都不是好办法。试试这4步协商法，和孩子一起制定双方都能接受的屏幕时间规则。',
    content: `## 数字时代的普遍困境

在这个数字时代，"孩子和屏幕"几乎是每个家庭都绕不开的话题。完全禁止不现实，完全放任又担心影响学习和视力。最好的办法是什么？协商。

## 四步协商法

### 第一步：召开家庭会议
选择一个大家心情都不错的时间，正式地坐下来讨论屏幕使用问题。让孩子参与规则的制定，而不是被动接受。

### 第二步：明确各自的担忧
- 妈妈的担忧：影响视力、占用学习时间、内容不安全……
- 孩子的诉求：和朋友联系、放松娱乐、看喜欢的内容……

把双方的担忧和需求都写在纸上，让彼此都能看到。

### 第三步：寻找共赢方案
- "每天完成作业后可以用30分钟平板"
- "周末可以多用1小时，但要保证户外活动时间"
- "睡前1小时不接触任何屏幕"
- "使用家长控制功能过滤不适当内容"

### 第四步：签订"屏幕使用协议"
把协商结果写成简单的协议，妈妈和孩子都签字。这不是法律文件，但仪式感能帮助双方更认真地对待约定。

## 协议之外

规则不是死板的。当孩子因为完成一个重要项目需要额外用电脑时，灵活调整。灵活不是软弱，而是智慧。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20family%20having%20a%20discussion%20around%20a%20dining%20table%20with%20a%20tablet%20placed%20in%20the%20center%2C%20warm%20lighting%2C%20harmonious%20atmosphere%2C%20cream%20and%20soft%20sage%20green%20tones%2C%20minimalist%20home%2C%20editorial%20photography&width=800&height=500&seq=article-screen-09&orientation=landscape',
    author: '赵老师',
    role: '家庭教育指导师',
    readTime: 6,
    date: '2024-10-20',
    featured: false,
    tags: ['屏幕时间', '数字素养', '家庭规则'],
  },
  // 升学规划
  {
    slug: 'primary-to-middle-school',
    title: '小升初全攻略：从五年级开始如何准备？',
    category: 'education-planning',
    excerpt: '小升初是孩子学习生涯的第一个重要节点。从五年级开始做好规划，帮助孩子顺利过渡到初中。本文梳理了关键时间节点和准备要点。',
    content: `## 为什么要提前准备？

很多家长到了六年级才开始着急，但小升初的准备其实从五年级就应该开始。提前规划不是为了"抢跑"，而是让整个过程更加从容有序。

## 五年级：打基础

**学科方面**：
- 语文：加强阅读理解和写作能力，每天保证30分钟课外阅读
- 数学：夯实四则运算和基础应用题，培养逻辑思维
- 英语：积累800-1000词汇量，培养听说能力

**习惯方面**：
- 培养独立记作业和整理错题本的习惯
- 学会自己规划复习时间
- 建立每日固定的学习时间

## 六年级上学期：全面冲刺

- 9月-10月：系统复习五六年级重点知识
- 11月-12月：开始做真题，熟悉题型和考试节奏
- 关注目标学校的招生政策和开放日信息

## 六年级下学期：选择与过渡

- 3月-4月：参加目标学校的说明会和开放日
- 5月-6月：参加考试/面试
- 7月-8月：暑假做好小升初衔接准备

## 给妈妈的建议

每个孩子都有自己的节奏。适合别人家孩子的学校不一定适合你的孩子。在选择学校时，除了升学率，更要考虑学校的教育理念是否与你家的教育观一致、学校离家距离是否合理、孩子的意愿是什么。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20child%20studying%20at%20a%20desk%20with%20a%20calendar%20and%20textbooks%2C%20organized%20study%20materials%2C%20warm%20natural%20light%2C%20cream%20and%20soft%20coral%20tones%2C%20minimalist%20interior%2C%20editorial%20photography&width=800&height=500&seq=article-primary-10&orientation=landscape',
    author: '刘老师',
    role: '升学规划顾问',
    readTime: 8,
    date: '2024-12-05',
    featured: true,
    tags: ['小升初', '升学规划', '学校选择'],
  },
  {
    slug: 'high-school-entrance-guide',
    title: '中考前半年，妈妈应该做些什么？',
    category: 'education-planning',
    excerpt: '中考不仅是孩子的战场，也是妈妈的考验。在中考前最后半年，妈妈的角色不是"监工"，而是最温暖的后盾。做好这5件事，陪孩子从容迎考。',
    content: `## 中考前半年：调整心态最关键

到了初三下学期，知识复习已经基本完成，这个阶段比拼的往往不是智力，而是心态和状态。妈妈最重要的任务，是帮助孩子保持稳定的情绪和良好的节奏。

## 五件妈妈应该做的事

### 1. 做"后勤部长"，不做"学习督导"
准备营养均衡的三餐，保证孩子有充足的睡眠，提醒适当运动。至于"这道题为什么还不会""这次模考怎么又退步了"，请把这些话咽回去。

### 2. 帮助孩子建立"考试节奏感"
按照中考时间安排周末的模拟练习——上午考什么就练什么，下午考什么就练什么。让身体和大脑提前适应考试节奏。

### 3. 成为孩子的"情绪容器"
当孩子焦躁、沮丧、想放弃的时候，不要急着给建议或讲道理。只需要说："妈妈知道你很难，没关系的，我们一起面对。"

### 4. 收集信息但不传递焦虑
关于学校录取分数线、招生政策等信息，妈妈自己了解就好，不要一股脑全倒给孩子。你的焦虑会变成Ta的压力。

### 5. 规划考后的放松
和孩子一起规划中考后的放松计划——去哪里玩、吃什么好吃的、看什么电影。让Ta知道，考试结束后有一个美好的"奖励"在等着。

## 最重要的提醒

中考很重要，但它不是人生的全部。无论结果如何，你的孩子都是独一无二的、值得被爱的。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20supportive%20mother%20hugging%20her%20teenage%20child%20in%20a%20warm%20home%20setting%2C%20backlit%20by%20soft%20window%20light%2C%20tender%20and%20encouraging%20moment%2C%20cream%20and%20soft%20amber%20tones%2C%20emotional%20lifestyle%20photography&width=800&height=500&seq=article-highschool-11&orientation=landscape',
    author: '刘老师',
    role: '升学规划顾问',
    readTime: 7,
    date: '2024-11-05',
    featured: false,
    tags: ['中考', '备考策略', '家庭支持'],
  },
  {
    slug: 'college-entrance-preparation',
    title: '高中三年升学规划时间轴：从高一到高三的关键节点',
    category: 'education-planning',
    excerpt: '从高一的选科到高三的志愿填报，高中三年每个阶段都有不同的重点。这份时间轴帮助妈妈们心中有数，从容陪伴孩子走过高中三年。',
    content: `## 高一：探索与适应

**第一学期**：
- 帮助孩子适应高中学习节奏
- 了解新高考选科政策
- 观察孩子的学科优势和兴趣

**第二学期**：
- 完成选科决策（结合兴趣、能力和未来专业方向）
- 开始积累综合素质评价材料
- 鼓励孩子参加1-2个社团活动

## 高二：深耕与积累

**全年重点**：
- 学考（合格考）准备
- 夯实各科基础，建立知识体系
- 关注目标高校的招生动态
- 如果有竞赛计划，合理安排时间

## 高三：冲刺与决策

**上学期**：
- 一轮复习紧跟学校节奏
- 保持良好的作息和心态
- 12月关注各校冬令营和自主招生信息

**下学期**：
- 3月-4月：二轮复习，查漏补缺
- 5月：回归基础，调整状态
- 6月：高考
- 6月下旬：志愿填报

## 妈妈的"不焦虑"指南

高中三年，妈妈最需要做的是：提供稳定的后方支持、学会适时地退后、尊重孩子的选择。你的平静，就是孩子最好的定心丸。`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20calendar%20and%20study%20plan%20on%20a%20clean%20desk%20with%20a%20cup%20of%20tea%2C%20organized%20and%20calm%20atmosphere%2C%20warm%20natural%20light%2C%20cream%20and%20soft%20sage%20green%20tones%2C%20minimalist%20interior%2C%20editorial%20photography&width=800&height=500&seq=article-college-12&orientation=landscape',
    author: '刘老师',
    role: '升学规划顾问',
    readTime: 7,
    date: '2024-10-12',
    featured: false,
    tags: ['高考', '升学规划', '高中阶段'],
  },
  {
    slug: 'study-abroad-guide',
    title: '要不要送孩子出国留学？一位过来人妈妈的真实经验',
    category: 'education-planning',
    excerpt: '留学热潮下，很多妈妈都在纠结：到底要不要送孩子出国？本文分享一位成功将孩子送入世界名校的妈妈的亲身经历和深度思考。',
    content: `## 不是所有孩子都适合留学

在做出决定之前，请先问自己三个问题：
1. 我的孩子有足够的独立生活能力吗？
2. 我的孩子是自己想去，还是我们想让Ta去？
3. 我们的家庭经济状况能支持这个决定吗？

如果这三个问题中有任何一个答案不确定，请不要急于做决定。

## 一位妈妈的分享

"我的女儿从初二开始就表达了想出国的意愿。我们没有立即答应，而是用了两年时间来准备：带她去短期游学体验、让她自己查资料了解目标学校、锻炼独立生活能力。到了高一，她已经能自己做饭、管理零花钱、独立安排学习计划。这时我们才确定：她是认真的，而且准备好了。"

## 留学准备的关键点

- 语言成绩（托福/雅思）至少提前一年半开始准备
- 课外活动要注重深度而非广度
- 文书准备要体现孩子的真实特质，不要过度包装
- 资金证明和签证材料尽早准备
- 心理建设同样重要——留学不只是学术挑战，更是文化适应的挑战`,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20teenager%20with%20a%20backpack%20looking%20at%20a%20university%20campus%20through%20a%20window%2C%20bright%20future%20ahead%2C%20warm%20and%20hopeful%20atmosphere%2C%20cream%20and%20soft%20coral%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-abroad-13&orientation=landscape',
    author: '周妈妈',
    role: '留学生家长代表',
    readTime: 8,
    date: '2024-09-18',
    featured: false,
    tags: ['留学', '教育选择', '国际教育'],
  },
];

export const featuredArticles = articles.filter(a => a.featured);

export const testimonials = [
  {
    id: 1,
    name: '李妈妈',
    child: '儿子小学四年级',
    content: '自从跟着"学生的妈妈"学习了科学陪读方法后，我不再每天吼着孩子写作业了。现在儿子放学回来会自己安排时间，我们的关系也变好了很多。',
    rating: 5,
  },
  {
    id: 2,
    name: '王妈妈',
    child: '女儿初中二年级',
    content: '青春期的女儿曾经和我几乎零交流，文章里的沟通技巧真的帮了大忙。现在女儿会主动跟我聊学校的事情了，这种改变比什么都珍贵。',
    rating: 5,
  },
  {
    id: 3,
    name: '张妈妈',
    child: '儿子高中一年级',
    content: '升学规划的文章让我对孩子的未来有了更清晰的认识，不再盲目焦虑了。按照时间轴一步步来，心里踏实多了。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈妈妈',
    child: '双胞胎小学二年级',
    content: '带两个娃的压力真的大，情绪管理那几篇文章我反复看了好几遍。学会了先照顾好自己的情绪，才有余力去爱孩子。',
    rating: 5,
  },
];

export const aboutInfo = {
  brandName: '学生的妈妈',
  tagline: '陪伴孩子成长的智慧指南',
  mission: '帮助每一位学生的妈妈从焦虑走向从容，用科学的方法和温暖的态度陪伴孩子成长。',
  vision: '成为华人妈妈最信赖的家庭教育平台，让每一个家庭都能收获幸福与成长。',
  foundingYear: '2024年',
  founder: '一群热爱教育、理解妈妈们的教育工作者',
  email: 'hello@lijinye.cn',
  address: '北京市朝阳区建国路88号',
  phone: '400-888-6666',
  stats: [
    { label: '原创文章', value: '200+' },
    { label: '订阅妈妈', value: '50,000+' },
    { label: '好评率', value: '98%' },
    { label: '教育专家', value: '30+' },
  ],
};